import React from 'react'

import {usersService} from 'services'
import requestHandler from 'utils/requestHandler'
import {logInUser} from 'utils/user'
import useUserContext from 'components/User/useUserContext'
import FormHandler from 'components/Form/FormHandler'
import BInput from 'components/Form/Fields/BInput'

const Register = ({history}) => {
  const {setUser} = useUserContext()

  const submitCallback = (values, setLoading) => {
    requestHandler(() => usersService.authNewUser(values), 'json')
      .then(response => {
        if (response.success) {
          logInUser(response, setUser, setLoading)
          history.push('/profile')
        } else {
          setLoading(false)
        }
      })
  }

  return (
    <FormHandler
      submitCallback={submitCallback}
      submitTitle={'Register'}
      className='basicForm'
    >
      <BInput
        fieldName='email' icon='mail' label='Email'
        rules={[
          {required: true, message: 'Please input your Email'},
          {type: 'email', message: 'The input is not valid Email'},
        ]}/>
      <BInput
        fieldName='password' icon='key' label='Password' password
        rules={[{required: true, message: 'Please input your password'}]}/>
      <BInput fieldName='name' icon='user' label='Name'/>
      <BInput fieldName='surname' icon='usergroup-add' label='Surname'/>
      <BInput fieldName='phone' icon='phone' label='Phone'/>
    </FormHandler>
  )
}

export default Register
